import fetchIntercept from "fetch-intercept";
import history from "./history";
import rootStore from "../src/stores/RootStore";
import Cookies from "universal-cookie";

export default fetchIntercept.register({
  request: function (url, config) {
    // Modify the url or config here
    return [url, config];
  },

  requestError: function (error) {
    // Called when an error occured during another 'request' interceptor call
    return Promise.reject(error);
  },

  response: function (response) {
    // Modify the reponse object
    if (
      response.status === 200 ||
      response.status === 401 ||
      response.status === 400 ||
      response.status === 409
    ) {
      if (response.url.includes("fetchInvoice?key")) {
        return response;
      } else {
        return response.json();
      }
    } else if (response.status === 204) {
      if (
        !window.location.pathname.includes("reg") &&
        !window.location.pathname.includes("ver") && 
        !window.location.pathname.includes("invalid")
      ) {
        const cookies = new Cookies();
        cookies.set("auth", false);
        cookies.set("auth", false, { domain: ".izenda.com" });
        
        history.push("/");
      }
      rootStore.sharedStore.resetAllData();
    } else if (response.status === 403 || response.status === 500) {
      const cookies = new Cookies();
      cookies.set("auth", false, { domain: ".izenda.com" });
      cookies.set("auth", false, { domain: "/" });
      rootStore.sharedStore.resetAllData();
      history.push("/");
    }
  },

  responseError: function (error) {
    console.log("error", error);
    // Handle an fetch error

    return Promise.reject(error);
  },
});



// WEBPACK FOOTER //
// ./src/interceptor.js